import { Component, Input, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Location } from '@angular/common';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
    selector: 'app-assessment-wizard',
    templateUrl: './assessment-wizard.component.html',
    styleUrl: './assessment-wizard.component.scss'
})
export class AssessmentWizardComponent {
    public items: MenuItem[];

    @Input() activeIndex: number = 0;

    constructor(
        private location: Location,
        private router: Router,
        private viewportScroller: ViewportScroller,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (this.activeIndex != undefined) this._reloadItems();
    }

    ngOnInit() {
        this._reloadItems();

        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => {
                this.viewportScroller.scrollToPosition([0, 0]);
            });
    }

    goBack() {
        this.location.back();
    }

    private _reloadItems() {
        this.items = [
            { label: $localize`Fuerza`, styleClass: (this.activeIndex > 0) ? 'icon-check' : '' },
            { label: $localize`Capacidad`, styleClass: (this.activeIndex > 1) ? 'icon-check' : '' },
            { label: $localize`Hábitos`, styleClass: (this.activeIndex > 2) ? 'icon-check' : '' },
            { label: $localize`Actividad`, styleClass: (this.activeIndex > 3) ? 'icon-check' : '' },
            { label: $localize`Composición`, styleClass: (this.activeIndex > 4) ? 'icon-check' : '' },
        ];
    }
}
